import { useCallback, useEffect, useRef, useState } from 'react';
import { browserReconnect, type BrowserConnectionStatus } from './browser-reconnect';

export function useBrowserReconnect(enabled: boolean, session: string, reconnect: (signal: AbortSignal) => Promise<void>) {
  const latest = useRef(reconnect); latest.current = reconnect;
  const controller = useRef<ReturnType<typeof browserReconnect> | undefined>(undefined);
  const [status, setStatus] = useState<BrowserConnectionStatus>('idle');
  useEffect(() => {
    setStatus('idle');
    if (!enabled) return;
    const current = browserReconnect(signal => latest.current(signal), setStatus);
    controller.current = current;
    return () => { current.dispose(); if (controller.current === current) controller.current = undefined; };
  }, [enabled, session]);
  return { status, connected: useCallback(() => controller.current?.connected(), []), disconnected: useCallback(() => controller.current?.disconnected(), []) };
}
